import { graphql, useMutation } from 'react-relay/hooks';

import { useDeleteBundleMutation } from '__generated__/useDeleteBundleMutation.graphql';

export const deleteBundleMutation = graphql`
  mutation useDeleteBundleMutation($input: DeleteCartBundleInput!) {
    deleteBundle(input: $input) {
      message
      code
      success
    }
  }
`;

export function useDeleteBundle() {
  const [commitDeleteBundle, isDeletingBundle] =
    useMutation<useDeleteBundleMutation>(deleteBundleMutation);

  return {
    commitDeleteBundle,
    isDeletingBundle,
  };
}
